(function () {
  var roots = document.querySelectorAll('.mdl-lp');
  var root = roots[roots.length - 1];
  if (!root) return;

  var packs = root.querySelectorAll('[data-mdl-packs] .pack');
  var addons = root.querySelectorAll('[data-mdl-addon]');
  var totalEls = root.querySelectorAll('[data-mdl-total], [data-mdl-sticky-total]');
  var labelEls = root.querySelectorAll('[data-mdl-sticky-label]');
  var buttons = root.querySelectorAll('[data-mdl-atc]');
  var sticky = root.querySelector('[data-mdl-sticky]');
  var selected = root.querySelector('[data-mdl-packs] .pack.on') || packs[0];
  if (!selected) return;

  function base() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function euro(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  function refresh() {
    var t = parseFloat(selected.getAttribute('data-price')) || 0;
    Array.prototype.forEach.call(addons, function (a) {
      if (a.checked) t += parseFloat(a.getAttribute('data-price')) || 0;
    });
    Array.prototype.forEach.call(totalEls, function (e) { e.textContent = euro(t); });
    Array.prototype.forEach.call(labelEls, function (e) { e.textContent = selected.getAttribute('data-label') || ''; });
  }

  Array.prototype.forEach.call(packs, function (p) {
    p.addEventListener('click', function () {
      Array.prototype.forEach.call(packs, function (x) { x.classList.remove('on'); });
      p.classList.add('on');
      selected = p;
      refresh();
    });
  });

  Array.prototype.forEach.call(addons, function (a) { a.addEventListener('change', refresh); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-mdl-stop]'), function (el) {
    el.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  function collect() {
    var items = [{ id: parseInt(selected.getAttribute('data-id'), 10), quantity: 1 }];
    Array.prototype.forEach.call(addons, function (a) {
      if (!a.checked) return;
      var id = a.getAttribute('data-id');
      var selId = a.getAttribute('data-select');
      if (selId) {
        var sel = root.querySelector('#' + selId);
        if (sel) id = sel.value;
      }
      if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
    });
    return items;
  }

  function openDrawer(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    var updated = new Event('cart:updated', { bubbles: true });
    updated.detail = {
      resource: cart,
      data: {
        source: 'mdl-landing',
        itemCount: cart.item_count,
        sections: cart.sections
      }
    };
    document.dispatchEvent(updated);
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    return true;
  }

  function addToCart(btn) {
    var original = btn.textContent;
    var b = base();
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.dataset.sectionId : null;

    btn.disabled = true;
    btn.textContent = 'Ajout en cours…';

    fetch(b + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: collect() })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      })
      .then(function () {
        if (!sectionId) {
          window.location.href = b + 'cart';
          return null;
        }
        return fetch(b + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            updates: {},
            sections: sectionId + ',auto-gifts',
            sections_url: window.location.pathname
          })
        }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        btn.disabled = false;
        btn.textContent = original;
        if (!openDrawer(cart)) window.location.href = b + 'cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        alert("L'ajout au panier a échoué. Merci de réessayer.");
      });
  }

  Array.prototype.forEach.call(buttons, function (b) {
    b.addEventListener('click', function () { addToCart(b); });
  });

  if (sticky) {
    var onScroll = function () {
      if (window.innerWidth > 900) { sticky.classList.remove('on'); return; }
      sticky.classList.toggle('on', window.scrollY > 420);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  refresh();
})();
